import { Link, Colors, Metrics, Button, Heading3, Text, Box, Helpers } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { CalculatorValuesInput } from '../../../../../../../__generated__/globalTypes';
import analytics from '../../../../../../analytics';

const RequestQuoteStyles = styled.div`
  margin-top: ${Metrics.Spacing.M_Y_LG}px;
  border-top: 1px solid ${Colors.GREY16};
`;

const Container = styled.div`
  max-width: 420px;
  margin: auto;
  margin-top: ${Metrics.Spacing.M_Y_SM}px;
  text-align: center;
  color: ${Colors.GREY};
  padding-left: 16px;
  padding-right: 16px;

  .textArea {
    margin-bottom: ${Metrics.Spacing.M_Y_SM}px;
  }

  & > * {
    display: inline-block;
  }

  ${Helpers.media.MD`
    .textArea {
      margin-bottom: ${Metrics.Spacing.M_Y}px;
    }
  `};
`;

const RequestButton = styled(Link)``;

export interface RequestQuoteProps {
  postcode: string;
  averageBill: string;
  usagePercentDuringDay: string;
}

export const RequestQuoteButton: React.SFC<RequestQuoteProps> = ({ postcode, averageBill, usagePercentDuringDay }) => {
  let url = '/solar/customers/contact.html';

  const mappedQS = {
    postcode: postcode,
    bill: Number(averageBill),
    mostUsage: usagePercentDuringDay
  } as CalculatorValuesInput;

  // Build the query string
  const qs = Object.entries(mappedQS)
    .reduce((_qs, [k, v]) => {
      _qs += `&${k}=${v.toString()}`;
      return _qs;
    }, '')
    .slice(1);

  url += `?${qs}`;

  return (
    <RequestQuoteStyles>
      <Container>
        <Heading3 text={'Get a tailored quote'} />
        <Box className="textArea">
          <Text size={'sm'} overflow="normal">
            Like the look of this estimate? Request a quote and one of our solar experts will get in touch. We
            {"'"}
            ll find the right solution for your home, your lifestyle, and you.
          </Text>
        </Box>
        <RequestButton href={url}>
          <Button
            data-id="requestAQuoteButton"
            text="Request a Quote"
            onClick={() => analytics.buttonClick('requestQuote', 'clicked')}
          />
        </RequestButton>
      </Container>
    </RequestQuoteStyles>
  );
};
